module.exports = __webpack_public_path__ + "img/content-1.02f7d045.png";